import { colors } from '@agria/theme/src/styles/tokens/colors';

import defaultTokens, {
  FormBaseTokens,
} from '@agria/theme/src/components/form/base/tokens';

const tokens: FormBaseTokens = {
  ...defaultTokens,
  tickFill: `data:image/svg+xml,%3Csvg width='13' height='12' viewBox='0 0 13 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.3.5a1.1 1.1 0 1 1 1.9 1.2l-6.3 9.7a1.1 1.1 0 0 1-1.8.1L.3 7.2A1.1 1.1 0 0 1 2 5.7l2.8 3.2L10.3.5Z' fill='${colors.brandTwo100.replace('#', '%23')}'/%3E%3C/svg%3E%0A`,
  tickWidth: '13px',
  tickHeight: '12px',
  tickLeft: '6px',
  checkedBackground: 'utilityWhite',
  checkedBorderColor: 'brandTwo100',
  checkboxBorderColor: 'brandTwo100',
  formFieldBorderColor: 'brandOne100',
} as const;

export default tokens;
